import { useEffect, useState } from 'react';
import BranchService from '../../services/branch/BranchService';
import RestaurantCorporateCafeteriaService from '../../services/restaurant/RestaurantCorporateCafeteriaService';
import type { IBranchDropdown } from '../../types/branches/branchInterfaces';
import type { CorporateAccountDTO } from '../../types/restaurant/RestaurantCorporateCafeteriaTypes';
import useApiErrorHandler from '../useApiErrorHandler';

export default function useCorporateCafeteriaContext() {
  const [branches, setBranches] = useState<IBranchDropdown[]>([]);
  const [branchId, setBranchId] = useState<number | ''>('');
  const [accounts, setAccounts] = useState<CorporateAccountDTO[]>([]);
  const [loadingContext, setLoadingContext] = useState(true);
  const { handle } = useApiErrorHandler();
  const loadAccounts = async (id = branchId) => {
    if (!id) { setAccounts([]); return; }
    try { const response = await RestaurantCorporateCafeteriaService.listAccounts(Number(id)); setAccounts(response.data || []); }
    catch (error) { handle(error); }
  };
  useEffect(() => { BranchService.fetchDropdown().then((items) => { setBranches(items || []); setBranchId(items?.[0]?.id || ''); }).catch(handle).finally(() => setLoadingContext(false)); }, []);
  useEffect(() => { loadAccounts(); }, [branchId]);
  return { branches, branchId, setBranchId, accounts, loadAccounts, loadingContext };
}
